import type { AxiosResponse } from 'axios';

import { request } from '../requestService';

const ENDPOINTS = {
  getSessionToken: 'pay',
  verifyPayment: 'pay/verify',
  getStatus: 'pay/status',
  getVoucher: 'pay/voucher',
};

export enum StatusCode {
  Success = '200',
  Unpaid = '201',
  Cancel = '400',
  CounterSelect = '5017',
  SystemError = '5555',
}

interface IGetSessionTokenResponse {
  status: string;
  message: string;
  session_token: string;
  redirectToGateway: string;
}

interface ITransactionDetails {
  id: number;
  lpcoId: number;
  sessionToken: string;
  statusCode: StatusCode;
  status: string;
  invoiceNo: string;
  invoiceDate: string;
  transactionId: string;
  transactionDate: string;
  paymentMode: string;
  totalAmount: number;
  totalPaidAmount: number;
}

export function getSessionToken(id: string, returnUrl: string): Promise<AxiosResponse<IGetSessionTokenResponse>> {
  return request({
    method: 'POST',
    url: `${ENDPOINTS.getSessionToken}/${id}?returnUrl=${returnUrl}`,
  });
}

export function verifyPayment(sessionToken: string): Promise<AxiosResponse<ITransactionDetails>> {
  return request({
    method: 'POST',
    url: `${ENDPOINTS.verifyPayment}/${sessionToken}`,
  });
}

export function getLpcoStatus(lpcoId: string): Promise<AxiosResponse<string>> {
  return request({
    url: `${ENDPOINTS.getStatus}/${lpcoId}`,
    skipErrorInterceptor: true,
  });
}

export function getVoucherByLicenseId(id: string): Promise<AxiosResponse<string>> {
  return request({
    url: `${ENDPOINTS.getVoucher}/${id}`,
    skipErrorInterceptor: true,
  });
}
